// extracted by mini-css-extract-plugin
export default {"root":"ReportListingLink_root__DzbB1","icon":"ReportListingLink_icon__x1rlz"};